import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("svg", {
    class: "icon",
    "aria-hidden": "true",
    "font-size": "40px"
  }, [
    /*#__PURE__*/_createVNode("use", { "xlink:href": "#iconshiliangzhinengduixiang" })
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_el_dropdown, {
      id: "size-select",
      trigger: "click",
      onCommand: _ctx.handleSetSize
    }, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sizeOptions, (item) => {
              return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: item.value,
                disabled: _ctx.size===item.value,
                command: item.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["disabled", "command"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["onCommand"]),
    _hoisted_2
  ]))
}